import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { colors } from '../styles/personalakteStyles';
import styles from './ContractHistoryTimeline.module.css';

interface CISelectProps {
  value: string;
  onChange: (value: string) => void;
  options: Array<{ value: string; label: string }>;
  placeholder?: string;
}

export const CISelect: React.FC<CISelectProps> = ({
  value,
  onChange,
  options,
  placeholder = 'Bitte wahlen...',
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedLabel = options.find(o => o.value === value)?.label || '';

  return (
    <div ref={ref} className={styles.ciSelectWrapper}>
      <div
        onClick={() => setOpen(prev => !prev)}
        className={styles.ciSelectTrigger}
        style={{ color: value ? colors.navy : undefined }}
      >
        <span className={!value ? styles.ciSelectPlaceholder : undefined}>
          {selectedLabel || placeholder}
        </span>
        <FaChevronDown
          className={styles.ciSelectChevron}
          style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}
        />
      </div>
      {open && (
        <div className={styles.ciSelectDropdown}>
          {options.map(opt => {
            const isActive = opt.value === value;
            return (
              <div
                key={opt.value}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                className={`${styles.ciSelectOption} ${isActive ? styles.ciSelectOptionActive : ''}`}
                style={{ color: isActive ? colors.slate : colors.navy }}
              >
                {opt.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
